import actions from 'actions/dashboardCharts'
import dashboardTemplateActions from 'actions/dashboardTemplates'
import { createFormViewContainer } from 'factories/FormView'
import Component from 'components/DashboardCharts/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    getExistingItem: (params) => dispatch(actions.getItem(params)),
    getChartTypes: (params) => dispatch(dashboardTemplateActions.getChartTypes(params)),
    getChartMetricTypes: (params) => dispatch(dashboardTemplateActions.getChartMetricTypes(params)),
    getDistributionTypes: (params) => dispatch(dashboardTemplateActions.getDistributionTypes(params)),
    getDimensionTypes: (params) => dispatch(dashboardTemplateActions.getDimensionTypes(params)),
  }),
})(Component)
